module.exports = __webpack_public_path__ + "static/media/user-avatar.3f0d2b16.jpg";